import * as React from "react";

const Input = React.forwardRef(
  (
    {
      className,
      label,
      type,
      isRequired,
      leftIcon,
      inputActions,
      rightIcon,
      hasError,
      ...props
    },
    ref
  ) => {
    return (
      <div>
        {label && (
          <label className="flex justify-between items-center mb-2">
            <span className=" text-gray-600 font-semibold">
              {label} {isRequired && <span className="text-red-600">*</span>}
            </span>

            {inputActions && <div className="shrink-0">{inputActions}</div>}
          </label>
        )}

        <div className="relative">
          {leftIcon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
              {leftIcon}
            </div>
          )}

          <input
            type={type}
            className={`flex h-10 w-full rounded-lg border text-gray-600 border-gray-200 bg-white text-sm ring-offset-white placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-50 ${
              leftIcon ? "pl-10" : "pl-3"
            } ${rightIcon ? "pr-10" : "pr-3"} py-2 ${className} ${
              hasError ? "border-red-500 focus:ring-red-500" : "border-gray-300"
            }`}
            ref={ref}
            {...props}
          />

          {rightIcon && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
              {rightIcon}
            </div>
          )}
        </div>
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
